import { memo, useCallback, useMemo } from 'react';
import { Box, Icon, PressableOverlay, Text } from '@betty/moonlight';
import { ShopFilterItemProps } from './ShopFilterItem.types';
import {
  shopFilterIconMap,
  shopSaleFilterIcon,
} from '../../content/shop.content';
import { useShopRouteParams, useShopFilterName } from '../../hooks';

function ShopFilterItem({ filter, isSelected }: ShopFilterItemProps) {
  const icon = useMemo(
    () => shopFilterIconMap[filter] ?? shopSaleFilterIcon,
    [filter],
  );

  const name = useShopFilterName(filter);

  const { setFilterParam } = useShopRouteParams();

  const onPress = useCallback(() => {
    setFilterParam(isSelected ? undefined : filter);
  }, [isSelected, filter, setFilterParam]);

  if (!name) {
    return null;
  }

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      marginHorizontal="space-100"
      paddingHorizontal="space-200"
      borderRadius="radius-600"
      alignSelf="flex-start"
      gap="space-100"
      height={36}
      {...(isSelected
        ? { variant: 'gradient', gradient: 'accentBackground' }
        : { backgroundColor: 'primaryBackground' })}
    >
      <Icon
        name={icon}
        width="space-400"
        height="space-400"
        {...(isSelected
          ? { color: 'iconPrimary' }
          : { gradient: 'accentBackground' })}
      />
      <Text
        variant="caption-semi"
        color={isSelected ? 'accentSurfacePrimary' : 'darkSurfacePrimary'}
      >
        {name}
      </Text>
      <PressableOverlay onPress={onPress} />
    </Box>
  );
}

export default memo(ShopFilterItem);
